// Default imports
import React from "react";

import { Row, Col } from "react-bootstrap";
import ContainerWide from "../ContainerWide";

const PageHeadConnectivity = ({ title, text, types, centered }) => {
    return (
        <ContainerWide
            className={`connectivity ${centered ? "-centered" : ""}`}
        >
            <Row>
                <Col xs="24">
                    {title && <h2 className="connectivity__header">{title}</h2>}

                    {centered && text && (
                        <Row className="connectivity__wrapper -intro">
                            <Col xs="24">
                                <p className="connectivity__text">{text}</p>
                            </Col>
                        </Row>
                    )}

                    {!centered && text && (
                        <Row className="connectivity__wrapper">
                            <Col xs="24" lg="18">
                                <p className="connectivity__text">{text}</p>
                            </Col>
                        </Row>
                    )}
                </Col>
            </Row>
        </ContainerWide>
    );
};

export default PageHeadConnectivity;
